import {Component, Input, OnInit} from '@angular/core';
import {KongService} from '../kong.service';
import {MatDialog} from '@angular/material/dialog';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {ConnecttocrudService} from '../connecttocrud.service';
import {CreateUserComponent} from './create-user-component/create-user.component';
import {EmailtemplateService} from '../emailtemplate.service';
import {ConfService} from '../conf.service';
import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {ViewRoleExclusionsComponent} from './view-role-exclusions/view-role-exclusions.component';
import {ResetPasswordDialogComponent} from './reset-password-dialog/reset-password-dialog.component';
import {AddEnvironmentDialogComponent} from './add-environment/add-environment-dialog.component';
import {environment} from '../../environments/environment';
import {AccountInfoService} from '../user/account-info.service';

@Component({
    selector: 'app-manage-users1',
    templateUrl: './manage-users1.component.html',
    styleUrls: ['./manage-users1.component.scss']
})
export class ManageUsers1Component implements OnInit {


    constructor(private confPost: ConfService,
                private kongService: KongService,
                public dialog: MatDialog,
                public platform: LeftpanelComponent,
                public _service: ConnecttocrudService,
                public accountInfoService: AccountInfoService,
                public router: Router,
                public emailTemplateInstance: EmailtemplateService) {
    }

    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    userDetails: any;
    dataFound = false;
    Roles = new FormControl();
    rolesList: any;
    filterData: any[];
    settings = {text: 'Select Roles'};
    searchText: any;
    select = true;
    environments = [];
    environmentList = [];
    associatedEnvironments = [];

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.getEnvironments();
        this.getUserDetails();
    }

    // getUserDetails() {
    //     this.dataFound = false;
    //     const partner = localStorage.getItem('partner');
    //     let userDetails: any;
    //     this._service.getItemswithParameter('v1',  environment.accessPartner, environment.accessPartner, 'users', 'created_by=' + localStorage.getItem('signInEmail')).subscribe(data1 => {
    //         if (data1) {
    //             userDetails = data1;
    //             if (userDetails.length > 0) {
    //                 this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=services,' + partner + '&&type.in=platform,account').subscribe(data => {
    //                     if (data) {
    //                         for (const user of userDetails) {
    //                             if (user['status']) {
    //                                 user['verification'] = 'verified';
    //                             } else {
    //                                 user['verification'] = 'Not verified';
    //                             }
    //                             const shortName = user['user'].split('-');
    //                             user['type'] = shortName[0];
    //                             const eList = [];
    //                             for (const e of user['environments']) {
    //                                 const shortcode = e['name'].split('-');
    //                                 e['type'] = shortcode[0];
    //                                 e['editStatus'] = true;
    //                                 e['roles' + e['name']] = e['roles'];
    //                                 e['rolesList'] = data;
    //                                 eList.push(e['name']);
    //                                 if (e['type'] !== 'admin')  {
    //                                     const role_list = [];
    //                                     e['platform_roles'] = [];
    //                                     for (const eee of e['rolesList']) {
    //                                         if (eee['role'] !== 'Platform Admin' && eee['role'] !== 'Super Admin' && !eee['role'].includes('=>')) {
    //                                             role_list.push(eee);
    //                                             e['platform_roles'].push(eee['id']);
    //                                         }
    //                                     }
    //                                     e['rolesList'] = role_list;
    //                                 }
    //                                 e['exlusions_peresent'] = false;
    //                                 if (e['exclusions']['permission_groups'].length > 0) {
    //                                     e['exlusions_peresent'] = true ;
    //                                     this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'id.in=' + e['exclusions']['permission_groups'].toString()).subscribe(permissiongroups => {
    //                                         e['exclusions']['permission_groups'] = permissiongroups;
    //                                     });
    //                                 }
    //                                 if (e['exclusions']['permissions'] > 0) {
    //                                     e['exlusions_peresent'] = true ;
    //                                     this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissions', 'id.in=' + e['exclusions']['permissions'].toString()).subscribe(permissions => {
    //                                         e['exclusions']['permissions'] = permissions;
    //                                     });
    //                                 }
    //
    //                                 if (e['exclusions']['roles'] > 0) {
    //                                     e['exlusions_peresent'] = true ;
    //                                     this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'id.in=' + e['exclusions']['permissions'].toString()).subscribe(roles => {
    //                                         e['exclusions']['roles'] = roles;
    //                                     });
    //                                 }
    //                             }
    //                             user['environmentList'] = eList;
    //                         }
    //                         this.dataFound = true;
    //                         this.userDetails = userDetails;
    //                     }
    //                 });
    //             }
    //         }
    //     });
    //
    //
    // }
    //
    //
    // openViewRoleDialog(event) {
    //     const dialogRef = this.dialog.open(ViewRoleExclusionsComponent, {
    //         width: '50%',
    //         data: {
    //             users: event
    //         }
    //     });
    // }

    getRolesForUserAndPlatform() {
        return new Promise((resolve, reject) => {
            let data = [];
            const platformRoles = new Promise((resolve1, reject1) => {
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=services' + '&&type.in=platform').subscribe(data1 => {
                    if (data1) {
                        data = data.concat(data1);
                    }
                    resolve1('success');
                }, error => {
                    resolve1('success');
                });
            });

            const accountRoles = new Promise((resolve1, reject1) => {
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=' + localStorage.getItem('partner') + '&&type.in=account').subscribe(data2 => {
                    if (data2) {
                        data = data.concat(data2);
                    }
                    resolve1('success');
                }, error => {
                    resolve1('success');
                });
            });

            Promise.all([platformRoles, accountRoles]).then(resp => {
                resolve(data);
            });
        });
    }

    async getUserDetails() {
        this.dataFound = false;

        if (this.platform.settingsData !== null && this.platform.settingsData !== undefined) {
            const adminEmail = this.platform.settingsData['body'][0]['email'];
            const partner = this.platform.settingsData['body'][0]['partner_name'];
            this.getUserRoleData(adminEmail, partner);
        } else {
            await this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(response => {
                if (response['body'] && response['body'][0]) {
                    this.platform.settingsData = response;
                    const adminEmail = this.platform.settingsData['body'][0]['email'];
                    const partner = this.platform.settingsData['body'][0]['partner_name'];
                    this.getUserRoleData(adminEmail, partner);
                }
            });
        }

    }

    getUserRoleData(adminEmail, partner) {
        let userDetails: any;
        let queryEmails = adminEmail;
        const signInEmail = localStorage.getItem('signInEmail');
        if (signInEmail !== queryEmails) {
            queryEmails = queryEmails + ',' + signInEmail;
        }
        this._service.getItemswithParameter('v1',  environment.accessPartner, environment.accessPartner, 'users', 'created_by=' + queryEmails + '&partner=' + partner).subscribe(data1 => {
            if (data1) {
                userDetails = data1;
                if (userDetails.length > 0) {
                    Promise.resolve(this.getRolesForUserAndPlatform()).then(data => {
                        if (data) {
                            for (const user of userDetails) {
                                if (user['status']) {
                                    user['verification'] = 'verified';
                                } else {
                                    user['verification'] = 'Not verified';
                                }
                                const shortName = user['user'].split('-');
                                user['type'] = shortName[0];
                                user['showActions'] = false;
                                user['resetPassword'] = false;
                                if (signInEmail === adminEmail) {
                                    if (user['email'] === adminEmail) {
                                        user['showActions'] = false;
                                    } else {
                                        user['showActions'] = true;
                                    }
                                    user['resetPassword'] = true;
                                } else {
                                    if (user['email'] === adminEmail) {
                                        user['showActions'] = false;
                                    } else if (user['email'] === signInEmail) {
                                        user['showActions'] = false;
                                        user['resetPassword'] = user['resetPassword'];
                                    } else {
                                        user['showActions'] = true;
                                    }
                                }

                                const eList = [];
                                for (const e of user['environments']) {
                                    const shortcode = e['name'].split('-');
                                    e['type'] = shortcode[0];
                                    e['showActions'] = user['showActions'];
                                    e['resetPassword'] = user['resetPassword'];
                                    e['editStatus'] = true;
                                    e['roles' + e['name']] = e['roles'];
                                    e['rolesList'] = data;
                                    eList.push(e['name']);
                                    if (e['type'] !== 'admin')  {
                                        const role_list = [];
                                        e['platform_roles'] = [];
                                        for (const eee of e['rolesList']) {
                                            if ((eee['role'] !== 'Platform Admin' && eee['role'] !== 'Super Admin' && eee['type'] === 'platform') || (!eee['role'].includes('=>') && eee['type'] === 'account')) {
                                                role_list.push(eee);
                                                e['platform_roles'].push(eee['id']);
                                            }
                                        }
                                        e['rolesList'] = role_list;
                                    } else {
                                        const role_list = [];
                                        e['platform_roles'] = [];
                                        for (const eee of e['rolesList']) {
                                            if ((eee['role'] === 'Platform Admin' && eee['type'] === 'platform')  || (!eee['role'].includes('=>') && eee['type'] === 'account')) {
                                                role_list.push(eee);
                                                e['platform_roles'].push(eee['id']);
                                            }
                                        }
                                        e['rolesList'] = role_list;
                                    }
                                    e['exlusions_peresent'] = false;
                                    if (e['exclusions']['permission_groups'].length > 0) {
                                        e['exlusions_peresent'] = true ;
                                        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'id.in=' + e['exclusions']['permission_groups'].toString()).subscribe(permissiongroups => {
                                            e['exclusions']['permission_groups'] = permissiongroups;
                                        });
                                    }
                                    if (e['exclusions']['permissions'] > 0) {
                                        e['exlusions_peresent'] = true ;
                                        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissions', 'id.in=' + e['exclusions']['permissions'].toString()).subscribe(permissions => {
                                            e['exclusions']['permissions'] = permissions;
                                        });
                                    }

                                    if (e['exclusions']['roles'] > 0) {
                                        e['exlusions_peresent'] = true ;
                                        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'id.in=' + e['exclusions']['permissions'].toString()).subscribe(roles => {
                                            e['exclusions']['roles'] = roles;
                                        });
                                    }
                                }
                                user['environmentList'] = eList;
                            }
                            this.dataFound = true;
                            this.userDetails = userDetails;
                        }
                    });
                }
            }
        });
    }


    openViewRoleDialog(event) {
        const dialogRef = this.dialog.open(ViewRoleExclusionsComponent, {
            width: '50%',
            data: {
                users: event
            }
        });
    }

    getEnvironments() {
        this.confPost.getSettingsV2CRUD(this.partner, this.partner, false).subscribe(response => {
            if (response) {

                for (const item of response['body'][0]['environments']) {
                    // if (item['type'] !== 'admin') {
                        this.environmentList.push(item['name']);
                    // }
                }
            }
        });
    }

    onItemSelect(item: any) {
    }

    toggleExecutor(ev, a) {
        $('.' + a).slideToggle();
        $(ev.target).toggleClass('fa-chevron-up fa-chevron-down');
    }

    openDialog(type): void {
        const dialogRef = this.dialog.open(CreateUserComponent, {
            width: '50%',
            data: {
                users: this.userDetails
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== undefined && result !== '') {
                this.userDetails = [];
                this.getUserDetails();
            }
        });
    }

    deleteEnvironment(eid, account, uid, email) {
        if (confirm('This action is irreversible, Are you sure you want to delete this user?')) {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'role=' + eid + '=>' + account + '=>' + email).subscribe(async res => {
                const tempRole = res[0];
                if(tempRole){
                    await this.deleteRoleForEachEnvironment(res[0]['id']);
                }
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id=' + uid).subscribe(data => {
                    let environments: any;
                    if (data && data[0] && data[0].hasOwnProperty('environments')) {
                        environments = data[0]['environments'];
                        if (environments.length > 0) {
                            const temp = environments.filter(value => value['name'] !== eid);
                            this._service.patchItemUpdate(uid, {environments: temp}, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(data => {
                                this.platform.openSnackBar(' Environments deleted successfully', 'Success', {
                                    duration: 2000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                this.userDetails = [];
                                this.getUserDetails();
                            });
                        }
                    }
                });
            });
        }
    }

    deleteRoleForEachEnvironment(id) {
        return new Promise((resolve, reject) => {
            this._service.deleteItem(id, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(data => {
                if (data) {
                    resolve('success');
                } else {
                    resolve('failed');
                }
            }, error => {
                /*this.platform.notifyErrorToAdmins({error: 'Error occurred while creating role for the user ' + roleDetail['role']}, 'role_create_success', 'role_create_failed', 'Error occurred while creating role for the user ' + roleDetail['role'], roleDetail);
                */
                resolve('failed');

            });
        });
    }

    editSelect(i1, i2) {

        this.userDetails[i1]['environments'][i2]['editStatus'] = false;
    }

    submitEnvironment(id, i1, i2, ngmodelName) {
        this.userDetails[i1]['environments'][i2]['editStatus'] = true;
        if (this.userDetails[i1]['environments'][i2][ngmodelName]) {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id=' + id).subscribe(data => {
                const temp = data[0]['environments'][i2]['roles'].filter(value => !this.userDetails[i1]['environments'][i2]['platform_roles'].includes(value));
                data[0]['environments'][i2]['roles'] = temp.concat(this.userDetails[i1]['environments'][i2][ngmodelName]);
                this._service.patchItemUpdate(id, {environments: data[0]['environments']}, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(response => {
                    if (response) {
                        this.platform.openSnackBar(' Environments Updated', 'Success', {
                            duration: 2000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.getUserDetails();
                    }

                });
            });
        }
    }

    addEnvironments(userIndex, id, email) {
        const environmentList = this.environmentList.filter(value => {
            if (!this.userDetails[userIndex]['environmentList'].includes(value)) {
                return value;
            }
        });

        const dialogRef = this.dialog.open(AddEnvironmentDialogComponent, {
            width: '25%',
            data: {
                id: id,
                environmentList: environmentList,
                emailId: email
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'success') {
                this.platform.openSnackBar(' New Environment Added ', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.getUserDetails();
            }
        });
    }

    resetPassword(i, user) {
        const dialogRef = this.dialog.open(ResetPasswordDialogComponent, {
            width: '25%',
            data: {
                user: user,
                environementIndex: i
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'success') {
                this.platform.openSnackBar(' Password has been changed ', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.getUserDetails();
            }
        });
    }

    deleteUser(id, username, status, emailId, environments) {
        if (confirm('This action is irreversible, Are you sure you want to delete this user?')) {
            for (let e of environments) {
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'role=' + e['name'] + '=>' + e['account'] + '=>' + emailId).subscribe(async res => {
                    let roles: any;
                    roles = res;
                    if(roles && roles.length>0 ){
                        await this.deleteRoleForEachEnvironment(roles[0]['id']);
                    }
                });
            }
            this._service.deleteItem(id, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(data => {
                 if (status && confirm('This action is irreversible, Are you sure you want to delete the associated consumer account?')) {
                     this.kongService.getKongGatewayConsumerDetails(emailId).subscribe(consumerDetail => {
                         const res = consumerDetail['data'][0];
                         this.kongService.deletKongConsumer(res['id']).subscribe(deletRes => {
                             if (deletRes) {
                                 this.platform.openSnackBar(' User and Consumer accounts deleted successfully', 'Success', {
                                     duration: 2000,
                                     verticalPosition: 'top',
                                     horizontalPosition: 'center'
                                 });
                             }
                             this.getUserDetails();
                         });
                     });
                 } else {
                     this.platform.openSnackBar(' User account deleted successfully', 'Success', {
                         duration: 2000,
                         verticalPosition: 'top',
                         horizontalPosition: 'center'
                     });
                     this.getUserDetails();
                 }
             });
        }
    }

    reRoute(id, environment) {
        this.router.navigateByUrl('/assign-roles?type=users&&id=' + id + '&&environment=' + environment);
    }


    sendInvite(id, emailId, partner, token, username) {
        let dt = new Date();
        dt.setMinutes(dt.getMinutes() + 15);
        const temp = localStorage.getItem('partner').split('-');
        const payload = {
            expires_at: (this.toTimestamp(dt)) * 1000
        };
        this._service.patchItemUpdate(id, payload, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(data => {

        });
        this.emailTemplateInstance.verifyUser.to.value[0].email = emailId;
        this.emailTemplateInstance.verifyUser.to.value[0].partner = partner;
        this.emailTemplateInstance.verifyUser.to.value[0].token = token;
        this.emailTemplateInstance.verifyUser.to.value[0].username = username;
        this.confPost.executeEmail(this.emailTemplateInstance.verifyUser).subscribe(response => {
            this.platform.openSnackBar(' Invitation has been sent  ', 'Success', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    stringifyjson(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }

    compareTimeStamp(expiryTimeStamp) {
        if (Date.now() < expiryTimeStamp) {
            return true;
        }
        return false;
    }

    toTimestamp(strDate) {
        const datum = Date.parse(strDate);
        return datum / 1000;
    }

}
